export default [
  {
    path: '/admin/trader/signal-launcher',
    name: 'SignalLauncher',
    component: () => import('@/views/Admin/Trader/SignalLauncher/Index.vue'),
    meta: {
      pageTitle: 'Signal Launcher',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Signal Launcher', active: true },
      ],
      resource: 'bots.list',
      action: 'read',
    },
  },
]
